module.exports = __webpack_public_path__ + "assets/img/shop_btn1.017c9b67.png";